import { useState, useEffect } from 'react'

const SECTION_IDS = ['search', 'apps', 'pricing', 'cta']

/**
 * Tracks which landing page section is currently in the viewport.
 * Returns the ID of the most visible section, or null if none.
 */
export function useActiveSection() {
  const [activeSection, setActiveSection] = useState<string | null>(null)

  useEffect(() => {
    const observers: IntersectionObserver[] = []
    const visibilityMap = new Map<string, number>()

    SECTION_IDS.forEach((id) => {
      const el = document.getElementById(id)
      if (!el) return

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            visibilityMap.set(id, entry.intersectionRatio)
          })

          // Find the section with the highest visibility
          let bestId: string | null = null
          let bestRatio = 0
          visibilityMap.forEach((ratio, sectionId) => {
            if (ratio > bestRatio) {
              bestRatio = ratio
              bestId = sectionId
            }
          })
          setActiveSection(bestRatio > 0 ? bestId : null)
        },
        { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
      )

      observer.observe(el)
      observers.push(observer)
    })

    return () => observers.forEach((o) => o.disconnect())
  }, [])

  return activeSection
}
